function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

/* eslint-disable */

/* tslint:disable */
import React from 'react';
import Share from 'wix-ui-icons-common/on-stage/Share';

var share_store = function share_store(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/React.createElement(Share, {
    size: "24"
  });
};

share_store.displayName = 'share_store';
export default share_store;
/* tslint:enable */

/* eslint-enable */